export default __webpack_public_path__ + "static/scrap-996acc29595a32223efb18090f379c5f.png";